export const ExternalTerminalConnectionStatus = {
    connected: 1,
    not_connected: 2,
    requested: 3,
    refused: 4,
};
